import React, { useState, useEffect, useRef } from 'react';
import './index.css'


export default function Map({ options, onMount, className }) {
  const ref = useRef()
  const [map, setMap] = useState()

  useEffect(() => {
    const onLoad = () => setMap(new window.google.maps.Map(ref.current, options))
    if (!window.google) {
      const script = document.createElement(`script`)
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB5-gkjdWxrp03tbm_Mq0RalCYog1VF0U4'
      document.head.append(script)
      script.addEventListener(`load`, onLoad)
      return () => script.removeEventListener(`load`, onLoad)
    } else onLoad()
  }, [options])

  if (map && typeof onMount === `function`) {
    onMount(map)
  }

  return (
    <div
      style={{ height: `100vh`, margin: `1em 0` }}
      {...{ ref, className }}
    />
  )
}
